var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_3453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 18.75V18.65H18H16.5H16.4V18.75V20.9H5.35V3.1H16.4V5.25V5.35H16.5H18H18.1V5.25V3C18.1 2.57565 17.9314 2.16869 17.6314 1.86863C17.3313 1.56857 16.9243 1.4 16.5 1.4H5.25C4.82565 1.4 4.41869 1.56857 4.11863 1.86863C3.81857 2.16869 3.65 2.57565 3.65 3V21C3.65 21.4243 3.81857 21.8313 4.11863 22.1314C4.41869 22.4314 4.82565 22.6 5.25 22.6H16.5C16.9243 22.6 17.3313 22.4314 17.6314 22.1314C17.9314 21.8313 18.1 21.4243 18.1 21V18.75ZM18.3717 15.3719L18.3012 15.4426L18.3718 15.5132L19.4293 16.5707L19.5 16.6414L19.5707 16.5707L24.0707 12.0707L24.1414 12L24.0707 11.9293L19.5707 7.42929L19.5 7.35858L19.4293 7.42929L18.3718 8.48679L18.3012 8.5574L18.3717 8.62811L20.8866 11.15H10.5H10.4V11.25V12.75V12.85H10.5H20.8866L18.3717 15.3719Z",
    fill: "#272729",
    stroke: "#272729",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_3453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.416fe9f210339cf6cb7871a2dfc8aa25.svg";
export { ForwardRef as ReactComponent };